// Other
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { Link } from 'react-router-dom'
import { WorkPageWrapper } from './ManagementAssetWarehouseStylePage'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import ManagementAssetWarehouseTable from './ManagementAssetWarehouseTable'
// Ant design
import { Button, Menu, message, Modal, Upload } from 'antd'
import {
  PlusOutlined,
  FileExcelOutlined,
  FileAddOutlined,
} from '@ant-design/icons'
// Component
import PageTitle from '../../components/PageTitle'

// Other
import AccessControlAction from '../../components/AccessControlAction'
import ManagementAssetWarehouseCreate from './ManagementAssetWarehouseCreate'
import { exportAssetWarehouse } from './ExportManagementAssetWarehouseExcel'
import { IoStorefrontOutline } from 'react-icons/io5'
import ManagementAssetWarehouseUpdate from './ManagementAssetWarehouseUpdate'
import moment from 'moment'
import ModalAssetPreView from './ModalAssetPreView'
import XLSX from 'xlsx'
import ManagementAssetWarehousePreviewModal from './ManagementAssetWarehousePreviewModal'
import ManagementAssetWarehouseRequest from '../../requests/ManagementAssetWarehouseRequest'

const ManagementAssetWarehousePage = props => {
  const {
    managementAssetWarehouseStore,
    loadingAnimationStore,
    fileStore,
  } = props

  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [selectedTemplateId, setSelectedTemplateId] = useState(null)
  const [checkImportStore, setCheckImportStore] = useState(false)
  const [currentDate] = useState(moment(new Date()).format('MM-YYYY'))
  const [importVisible, setImportVisible] = useState(false)
  const [fileExcel, setFileExcel] = useState(null)
  const [preViewVisible, setPreViewVisible] = useState(false)
  const [dataExcel, setDataExcel] = useState(null)
  const [isVisiblePreviewModal, setIsVisiblePreviewModal] = useState(false)
  const [listDataPreview, setListDataPreview] = useState([])
  const [listDataCurrent, setListDataCurrent] = useState([])
  const [isLoadingCreate, setIsLoadingCreate] = useState(false)

  const { managementAssetTypes } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  useEffect(() => {
    if (fileExcel == null) return
    handleGetDataExcel()
  }, [fileExcel])

  const handleGetDataExcel = async () => {
    if (!fileExcel) {
      message.error('Bạn chưa chọn file Excel.')
      return
    }
    const fileExtension = fileExcel.name.split('.').pop()

    if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
      message.error('Định dạng file không đúng.')
      return
    }
    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', fileExcel)
    try {
      const response = await fileStore.sendDataAssetExcel(formData)
      setDataExcel(response)
      setPreViewVisible(true)
      loadingAnimationStore.showSpinner(false)
    } catch (error) {
      console.error('Error importing Excel:', error)
      message.error('Đã xảy ra lỗi khi import file Excel.')
      loadingAnimationStore.showSpinner(false)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const exportBetRefundExcel = async () => {
    try {
      await managementAssetWarehouseStore.setFilter('pageIndex', 0)
      await managementAssetWarehouseStore.setFilter('sizeIndex', 999999)
      await managementAssetWarehouseStore.getManagementAssetWarehousetList()
      await exportAssetWarehouse(
        managementAssetWarehouseStore.managementAssetWarehouseList
      )
    } catch (error) {
      console.log(error)
    } finally {
      await managementAssetWarehouseStore.setFilter('sizeIndex', 10)
    }
  }

  const handleOpenUpdateModal = id => {
    setCheckImportStore(!checkImportStore)
    setIsVisibleUpdateModal(true)
    setSelectedTemplateId(id)
  }
  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
    setCheckImportStore(!checkImportStore)
  }

  const handleToggleCreateModal = bool => event => {
    setIsVisibleCreateModal(bool)
  }
  const handleTogglePreviewModal = bool => event => {
    setIsVisiblePreviewModal(bool)
    managementAssetWarehouseStore.setQueryParams('sizeIndex', 10)
  }

  const handleCancelImport = () => {
    setImportVisible(false)
    setFileExcel(null)
    managementAssetWarehouseStore.setQueryParams('sizeIndex', 10)
  }

  const normalizeString = str => {
    return str
      ?.normalize('NFD') // Tách chữ cái và dấu
      ?.replace(/[\u0300-\u036f]/g, '') // Xóa dấu
      ?.toLowerCase() // Chuyển về chữ thường
  }

  const propData = {
    beforeUpload: file => {
      const isXlsx =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isXlsx) {
        message.error('Vui lòng tải lên tệp XLSX hợp lệ!')
      }
      return false
    },
    onChange: info => {
      if (info.fileList && info.fileList.length > 0) {
        let reader = new FileReader()
        reader.readAsBinaryString(
          info.fileList[info.fileList.length - 1].originFileObj
        )
        reader.onload = e => {
          let data = e.target.result
          let workbook = XLSX.read(data, { type: 'binary' })
          let first_sheet_name = workbook.SheetNames[0]
          let worksheet = workbook.Sheets[first_sheet_name]
          let rows = XLSX.utils.sheet_to_json(worksheet, {
            raw: false,
            header: 1,
            blankrows: true,
          })

          if (rows.length >= 5) {
            const groupedData = {}
            let currentGroup = null
            let currentGroupName = null
            // tách data thành các nhóm dựa vào ký tự đầu tiên của dòng
            rows.forEach(row => {
              // Nếu dòng là nhóm (dựa vào việc chỉ có 2 cột và ký tự đầu tiên là chữ cái)
              if (row.length === 2 && /^[A-Z]$/.test(row[0])) {
                currentGroup = row[0] // Gán mã nhóm (A, B, ...)
                currentGroupName = row[1] // Gán tên nhóm ("GIẤY CÁC LOẠI", ...)
                groupedData[currentGroup] = {
                  name: currentGroupName,
                  items: [],
                } // Khởi tạo nhóm mới
              } else if (currentGroup && row.length > 2) {
                // Thêm dữ liệu vào nhóm hiện tại
                groupedData[currentGroup].items.push(row)
              }
            })

            // Thay thế tên nhóm bằng id dựa theo danh sách loại văn phòng phẩm
            for (const item of managementAssetTypes) {
              const normalizedDescription = normalizeString(item.description)

              // Không biết nguyên nhân vì sao groupedDate lại có key là number
              for (const groupKey in groupedData) {
                if (typeof groupedData[groupKey]?.name === 'string') {
                  const normalizedGroupName = normalizeString(
                    groupedData[groupKey]?.name
                  )
                  if (normalizedDescription === normalizedGroupName) {
                    groupedData[groupKey].name = item.id // Thay thế name bằng id
                  }
                }
              }
            }

            const result = []
            const notFoundName = []
            // Duyệt qua các nhóm
            Object.keys(groupedData).forEach(groupKey => {
              const group = groupedData[groupKey]

              if (typeof group.name !== 'string') {
                const items = group.items
                // Duyệt qua các items trong nhóm
                items.forEach(item => {
                  const newItem = {
                    asset_name: item[1], // Tên (Giấy A4, Giấy A3, ...)
                    asset_unit_name: item[2], // Đơn vị (ram, cuộn, ...)
                    tax: item[3].replace('%', '').trim(), // Thuế (8%)
                    price: item[4].replace(/[^0-9.-]+/g, ''), // Đơn giá trước thuế (chuyển thành số, bỏ ký tự không phải số)
                    total_money: item[5].replace(/[^0-9.-]+/g, ''), // Đơn giá sau thuế (chuyển thành số, bỏ ký tự không phải số)
                    amount: item[6] ? item[6] : 0, // Số lượng (14, 10, ...)
                    asset_type_id: group.name, // Thêm trường 'type' là tên nhóm ("GIẤY CÁC LOẠI", ...)
                    property: null,
                  }
                  result.push(newItem) // Thêm item mới vào mảng kết quả
                })
              } else {
                notFoundName.push(group.name)
              }
            })
            if (notFoundName.length > 0) {
              message.error(
                `Không tìm thấy loại văn phòng phẩm: ${notFoundName.join(', ')}`
              )
            }
            setImportVisible(false)
            setIsVisiblePreviewModal(true)
            setListDataPreview(result)
          }
        }
      }
      return false
    },
  }

  const handleCreateListAssetWarehouse = async () => {
    try {
      setIsLoadingCreate(true)
      const result = listDataPreview.filter(
        preview =>
          !listDataCurrent.some(
            current => current.asset_name === preview.asset_name
          )
      )
      const res = await ManagementAssetWarehouseRequest.createManagementAssetListWarehouse(
        result
      )
      await managementAssetWarehouseStore.setQueryParams('sizeIndex', 10)
      if (res.status === 200) {
        message.success(`${res.data}`)
        await managementAssetWarehouseStore.getManagementAssetWarehousetList()
        setIsVisiblePreviewModal(false)
      }
    } catch (error) {
      console.error('Error creating asset list:', error)
      message.error('Đã xảy ra lỗi khi tạo mới tài sản.')
    } finally {
      setIsLoadingCreate(false)
    }
  }

  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Tài sản</title>
        </Helmet>

        <PageTitle location={props.location}>
          <AccessControlAction check={true}>
            <div>
              <Button
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={() => setImportVisible(true)}>
                <FileAddOutlined />
                Nhập file excel
              </Button>
              <Button
                disabled={selectedRowKeys?.length > 0 ? false : true}
                style={{ marginRight: '10px' }}
                type={'primary'}
                icon={
                  <span style={{ marginRight: 8 }}>
                    <IoStorefrontOutline />
                  </span>
                }
                onClick={() => handleOpenUpdateModal(selectedRowKeys[0])}>
                Nhập kho
              </Button>
              <Button
                style={{ marginRight: '10px' }}
                icon={<FileExcelOutlined />}
                onClick={() => exportBetRefundExcel()}>
                Xuất excel (.xlsx)
              </Button>
              <Button
                type={'primary'}
                icon={<PlusOutlined />}
                onClick={handleToggleCreateModal(true)}>
                Tạo mới
              </Button>
            </div>
          </AccessControlAction>
        </PageTitle>
        <ContentBlockWrapper>
          <Menu
            mode="horizontal"
            selectedKeys={[props.location?.pathname]}
            style={{ marginBottom: 16 }}>
            <Menu.Item key="/manager-inventory/inventory-asset">
              <Link to={'/manager-inventory/inventory-asset'}>Tài sản</Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/manage-inventory-asset">
              <Link to={'/manager-inventory/manage-inventory-asset'}>
                Loại văn phòng phẩm
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/statistic">
              <Link to={'/manager-inventory/statistic'}>
                Thống kê tài sản tháng {currentDate}
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/export-statistic">
              <Link to={'/manager-inventory/export-statistic'}>
                Báo cáo sử dụng văn phòng phẩm theo tháng {currentDate}
              </Link>
            </Menu.Item>
          </Menu>

          <ManagementAssetWarehouseTable
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </ContentBlockWrapper>
      </DashboardLayout>
      <Modal
        width={700}
        title={'Tạo mới tài sản'}
        visible={isVisibleCreateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleCreateModal && (
          <ManagementAssetWarehouseCreate
            onCancel={handleToggleCreateModal(false)}
          />
        )}
      </Modal>
      <Modal
        width={1200}
        title={'Xem trước tạo mới tài sản'}
        visible={isVisiblePreviewModal}
        maskClosable={false}
        onCancel={handleTogglePreviewModal(false)}
        footer={[
          <Button key="cancel" onClick={handleTogglePreviewModal(false)}>
            Đóng
          </Button>,
          <Button
            loading={isLoadingCreate}
            key="create"
            type="primary"
            onClick={handleCreateListAssetWarehouse} // Thêm logic cho hàm này
          >
            Tạo mới
          </Button>,
        ]}
        destroyOnClose>
        {isVisiblePreviewModal && (
          <ManagementAssetWarehousePreviewModal
            isLoadingCreate={isLoadingCreate}
            listDataPreview={listDataPreview}
            listDataCurrent={listDataCurrent}
            managementAssetTypes={managementAssetTypes}
            onCancel={handleTogglePreviewModal(false)}
          />
        )}
      </Modal>
      <Modal
        width={700}
        title={'Nhập kho'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleCancelUpdateModal}
        footer={null}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <ManagementAssetWarehouseUpdate
            onCancel={handleCancelUpdateModal}
            templateId={selectedTemplateId}
            checkImportStore={checkImportStore}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        )}
      </Modal>
      <Modal
        title="Nhập file excel"
        visible={importVisible}
        onCancel={handleCancelImport}
        footer={[
          <Button danger ghost onClick={handleCancelImport}>
            Hủy
          </Button>,
          <Button>
            <Link
              to={`/etc/Template.xlsx?date=${moment().format(
                'YYYY-MM-DD-HH-mm-ss'
              )}`}
              target="_blank"
              download
              style={{ color: '#0076ff', textDecoration: 'underline' }}>
              Tải mẫu
            </Link>
          </Button>,
          <Upload
            {...propData}
            showUploadList={false}
            accept={
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }>
            <Button
              style={{ marginLeft: '10px' }}
              icon={<FileExcelOutlined />}
              onClick={async () => {
                await managementAssetWarehouseStore.setQueryParams(
                  'sizeIndex',
                  999999
                )
                await managementAssetWarehouseStore.fetchManagementAssetTypeList()
                const result = await ManagementAssetWarehouseRequest.getManagementAssetWarehouseList(
                  `page=0&size=999999`
                )
                setListDataCurrent(result.data.data)
              }}>
              Import excel
            </Button>
          </Upload>,
        ]}
      />

      {preViewVisible && (
        <ModalAssetPreView
          data={dataExcel}
          setPreViewVisible={setPreViewVisible}
          onCancel={() => setPreViewVisible(false)}
        />
      )}
    </WorkPageWrapper>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore',
  'fileStore'
)(observer(ManagementAssetWarehousePage))
